<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol sm="6" md="6" xl="6">
                  <BaseInput
                    :options="codeInput.options"
                    :data="codeInput.data"
                  />
                  <BaseInput
                    :options="nameInput.options"
                    :data="nameInput.data"
                  />
                  <BaseSelect
                    :options="isActiveSelect.options"
                    :data="isActiveSelect.data"
                    ref="isActive"
                  >
                  </BaseSelect>
                </CCol>
              </CRow>
              <div slot="footer" class="mt-4">
                <CButton
                  color="primary"
                  class="btn-action-primary mr-2"
                  @click="submitData"
                >
                  <i class="fa fa-refresh"></i> Cập nhật
                </CButton
                >
                <CButton
                  color="secondary"
                  class="btn-action-primary"
                  @click="$router.push(`/policy-management/managed-policies`)"
                ><i class="fa fa-reply"></i> Hủy bỏ
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CRow>
      <CCol md="12">
        <CCard>

          <CCardHeader>
            <h5>Danh sách chi tiết chính sách</h5>
          </CCardHeader>

          <CCardBody>
            <PolicyDetailList ref="policyDetailList"></PolicyDetailList>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    
 

  </div>
</template>

<script>
import BaseSelect from "../base/BaseSelect2";
import BaseInput from "../base/BaseInput";
import BaseLoading from "../base/BaseFormLoading";
import PolicyDetailList from '../policy_detail/PolicyDetailList.vue';

export default {
  name: "PolicyUpdate",
  components: {BaseSelect, BaseInput, BaseLoading, PolicyDetailList},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      idField: {
        data: {
          model: that.$route.params.id,
          name: "id"
        }
      },
      codeInput: {
        options: {
          label: "Mã chính sách *",
          placeholder: "Mã chính sách",
          type: "text",
          maxlength: 100
        },
        data: {
          name: "code",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.codeInput.data.model;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Mã chính sách không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      nameInput: {
        options: {
          label: "Tên chính sách *",
          placeholder: "Tên chính sách",
          type: "text",
          maxlength: 200
        },
        data: {
          name: "name",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.nameInput.data.model;
              if (value === "" || value === null) {
                this.isValid = false;
                this.errorMessage = "Tên chính sách không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      isActiveSelect: {
        options: {
          filter: false,
          label: 'Trạng thái',
        },
        data: {
          name: "active",
          items: [
            {key: "true", value: "Hoạt động"},
            {key: "false", value: "Không hoạt động"},
          ],
          model: 'true'
        }
      }
    };
  },
  methods: {
    getData: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/policy/findById",
        dataSubmit: function () {
          return {id: that.idField.data.model}
        },
        isJsonContentType: false,
        successCallback: function (response) {
          let dataRes = response.data.data;
          dataRes.active = dataRes.active+"";
          that.dataCache = that.$helper.setupDataResponse(that.$data, dataRes);
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    submitData: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/policy/updatePolicy",
        dataRef: function () {
          return that.$data;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({message: "Cập nhật chính sách thành công"});
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
  },
  computed: {},
  created() {
  },
  mounted() {
    this.getData();
  },
  watch: {}
};
</script>
